import { render } from "./detail.vue?vue&type=template&id=5b323e63&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=5b323e63&lang=scss&scoped=true"

import exportComponent from "F:\\Code3\\hwh-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b323e63"]])

export default __exports__